module.exports = __webpack_public_path__ + "img/002.6972742e.png";